/**
 * Generated by orval v6.10.1 🍺
 * Do not edit manually.
 * Platform API
 * The Platform API
 * OpenAPI spec version: 2.0
 */

export type CardAccountWithdrawResponseStatus = typeof CardAccountWithdrawResponseStatus[keyof typeof CardAccountWithdrawResponseStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CardAccountWithdrawResponseStatus = {
  pending: 'pending',
  posted: 'posted',
  declined: 'declined',
  void: 'void',
} as const;
